<div class="alert alert-info text-center guidelines">
  {{ "Please read the equipment migration guidelines" | translate }}
  <a
    class="btn btn-primary btn-block mt-4"
    href="https://welcome.astrobin.com/equipment-migration-guidelines"
    target="_blank"
  >
    <strong>{{ "Read" | translate }}</strong>
  </a>
</div>
